export default __webpack_public_path__ + "static/media/Request.8a650ca9.jpg";